import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import React from 'react'
import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { historyUtils } from '@wartek-id/fe-toolbox'

import WebinarList from 'app/PelatihanMandiriPage/pages/WebinarList'
import { useScreenSizeContext } from 'utils/hooks/context/useScreenSizeContext'
import { DesktopLayout } from 'components/Layout/Desktop/DesktopLayout'

dayjs.extend(utc)
dayjs.extend(timezone)

const WebinarPage = () => {
  const { isDesktop } = useScreenSizeContext()

  if (isDesktop) {
    return <DesktopLayout submenu={<WebinarList isDesktop={isDesktop} />} />
  }

  return <WebinarList />
}

const PageHeader = () => {
  const router = useRouter()

  return (
    <HeaderBar borderless fixed className="z-10">
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            arrow_back
          </Icon>
        }
        onClick={() => historyUtils.backToApp(router.back)}
      />
      <HeaderBarTitle>Webinar Pelatihan Mandiri</HeaderBarTitle>
    </HeaderBar>
  )
}

WebinarPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10',
  header: PageHeader,
  enableDesktopLayout: true,
}

export default WebinarPage
